import { exec, getApiToken } from '@src/apis/reware/utils';

export interface FetchSftpFoldersArgs {
  partnerCode: string;
  token: string;
}

interface FetchSftpFoldersExecVariables {
  token: string;
  partnerCode: string;
}

interface FetchSftpFoldersExecResponse {
  restUser: {
    partner: {
      sftpFolders: string[];
    };
  };
}

/**
 * Fetches the partner's allowed top-level SFTP folder entries (e.g.
 * `["downloads", "uploads"]`). Which entries are returned is governed
 * entirely by the partner's SFTP PEM key scoping on the backend.
 */
export const fetchSftpFolders = async (
  { partnerCode, token }: FetchSftpFoldersArgs
): Promise<string[]> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getSftpFolders(
      $token: String!
      $partnerCode: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          sftpFolders
        }
      }
    }
  `;

  const data = await exec<FetchSftpFoldersExecVariables, FetchSftpFoldersExecResponse>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );

  return data.restUser.partner.sftpFolders ?? [];
};
